export enum Direction {
  Input = 'input',
  Output = 'output',
}
